import {
  Cell,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
} from 'recharts';
import type { ClusterOutlierPoint } from '@avisoma/shared';
import { clusterColor } from './clusterColor';
import { ClusterTooltip } from './ClusterTooltip';

export function ClusterEmbeddingMap({
  points,
  threshold,
  hoveredId,
  onHover,
  onSelect,
}: {
  points: ClusterOutlierPoint[];
  threshold: number | null;
  hoveredId: number | null;
  onHover: (id: number | null) => void;
  onSelect: (id: number) => void;
}) {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-900 dark:text-zinc-100">Embedding map (PCA)</h3>
      <div className="mt-2 h-56 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart accessibilityLayer={false} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
            <XAxis type="number" dataKey="x" domain={['auto', 'auto']} hide />
            <YAxis type="number" dataKey="y" domain={['auto', 'auto']} hide />
            <ZAxis type="number" dataKey="pageCount" range={[30, 300]} />
            <Tooltip content={<ClusterTooltip />} />
            <Scatter data={points} cursor="pointer" onMouseLeave={() => onHover(null)}>
              {points.map((point) => (
                <Cell
                  key={point.id}
                  fill={clusterColor(point, threshold)}
                  fillOpacity={hoveredId === null || hoveredId === point.id ? 0.7 : 0.15}
                  onMouseEnter={() => onHover(point.id)}
                  onClick={() => onSelect(point.id)}
                />
              ))}
            </Scatter>
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
